module.exports = __webpack_public_path__ + "img/1.60d16461.png";